import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'

import { STORE_KEY_ACCOUNT, STORE_KEY_LIST } from 'Constants'
import { storeGet } from 'Helpers/localStorage'
import { dateFormat } from 'Helpers/dates'

import {
  toastShow,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_WARNING
} from 'mailup-web-components'
import { notifyParent } from 'Helpers/notifyParent'

const GracePeriodWarning = () => {
  const intl = useIntl()

  const { GracePeriod, GracePeriodNote, SuspendType, SuspendDate } = storeGet(
    STORE_KEY_ACCOUNT
  )

  const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

  const handleMshopClick = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshoppl'
    ])
  }

  const getSuspensionDescription = code => {
    switch (code) {
      case 0:
        return ' '
      case 1:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason1' })
      case 2:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason2' })
      case 3:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason3' })
      case 4:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason4' })
      case 5:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason5' })
      case 6:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason6' })
      case 7:
        return intl.formatMessage(
          { id: 'Load.GracePeriod.Reason7' },
          {
            linebreak: <br />,
            a: chunks => <a onClick={handleMshopClick}>{chunks}</a>
          }
        )
      case 8:
        return intl.formatMessage({ id: 'Load.GracePeriod.Reason8' })
      default:
        return ''
    }
  }

  const renderGracePeriodMessage = () => {
    const motivazione = getSuspensionDescription(SuspendType)

    const scadenza = SuspendDate
      ? new Date(Date.parse(SuspendDate) + 10 * 86400 * 1000) // +10 giorni
      : undefined

    const format = intl.locale === 'en' ? 'MM/DD/YYYY' : 'DD/MM/YYYY'

    const scadenzaDescr = scadenza
      ? dateFormat(scadenza, TimeZoneCode, format)
      : undefined

    return (
      <>
        {GracePeriod === 1 &&
          intl.formatMessage(
            { id: 'Load.ListDashboard.MsgGracePeriod1New' },
            { scadenza: scadenzaDescr, motivazione: motivazione }
          )}
        {GracePeriod === 2 &&
          intl.formatMessage(
            { id: 'Load.ListDashboard.MsgGracePeriod2New' },
            { motivazione: motivazione }
          )}
        {GracePeriodNote && (
          <>
            <br />
            {GracePeriodNote}
          </>
        )}
      </>
    )
  }

  useEffect(() => {
    if (GracePeriod) {
      const msg = renderGracePeriodMessage()

      toastShow(
        msg,
        GracePeriod === 1 ? TOAST_VARIANT_WARNING : TOAST_VARIANT_ERROR,
        'gracePeriod',
        false
      )
    }
  }, [])

  return null
}

export default GracePeriodWarning
